import Button from '@mui/material/Button';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';
import Input from '@mui/material/Input';
import LogoutIcon from '@mui/icons-material/Logout';
import UserIcon from '@mui/icons-material/PersonPin';
import RoleIcon from '@mui/icons-material/People'
import ReplyIcon from '@mui/icons-material/Reply';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import InputLabel from '@mui/material/InputLabel';
import Container from '@mui/material/Container';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Slider from '@mui/material/Slider';
import Switch from '@mui/material/Switch';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import Chip from '@mui/material/Chip';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import Paper  from '@mui/material/Paper';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Drawer from '@mui/material/Drawer';
import MuiDrawer from "@mui/material/Drawer";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Link from '@mui/material/Link';
import Menu from '@mui/material/Menu';
import Pagination from '@mui/material/Pagination';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ApartmentIcon from '@mui/icons-material/Apartment';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import TablePagination from '@mui/material/TablePagination';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import InputAdornment from '@mui/material/InputAdornment';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PersonIcon from '@mui/icons-material/Person';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import CloseIcon from '@mui/icons-material/Close';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CardActionArea from '@mui/material/CardActionArea';
import AddIcon from '@mui/icons-material/Add';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import DoneIcon from '@mui/icons-material/Done';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import InventoryIcon from '@mui/icons-material/Inventory';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CameraswitchIcon from '@mui/icons-material/Cameraswitch';
import CallEndIcon from '@mui/icons-material/CallEnd';
import MicOffIcon from '@mui/icons-material/MicOff';
import MicIcon from '@mui/icons-material/Mic';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import CancelIcon from '@mui/icons-material/Cancel';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import FolderIcon from '@mui/icons-material/Folder';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import DownloadIcon from '@mui/icons-material/Download';
import DescriptionIcon from '@mui/icons-material/Description';
import MuiAppBar from '@mui/material/AppBar';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import GroupIcon from '@mui/icons-material/Group';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import HomeIcon from '@mui/icons-material/Home';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import BookIcon from '@mui/icons-material/Book';
import MedicationIcon from '@mui/icons-material/Medication';
import ReceiptIcon from '@mui/icons-material/Receipt';
import MobileStepper from '@mui/material/MobileStepper';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import FormGroup from '@mui/material/FormGroup';
import UploadIcon from '@mui/icons-material/Upload';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import OutlinedInput from '@mui/material/OutlinedInput';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import TabList from '@mui/lab/TabList';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import SendIcon from '@mui/icons-material/Send';
import ListIcon from '@mui/icons-material/List';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import StoreIcon from '@mui/icons-material/Store';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { DateTimeField } from '@mui/x-date-pickers/DateTimeField';
import PrintIcon from '@mui/icons-material/Print';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import Skeleton from '@mui/material/Skeleton';
import CircularProgress from '@mui/material/CircularProgress';
import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CampaignIcon from '@mui/icons-material/Campaign';
import TextsmsIcon from '@mui/icons-material/Textsms';
import PhotoSizeSelectActualIcon from '@mui/icons-material/PhotoSizeSelectActual';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import ReplayIcon from '@mui/icons-material/Replay';
import { Grid } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import Alert from '@mui/material/Alert';
import Fade from '@mui/material/Fade';
import AddLinkIcon from '@mui/icons-material/AddLink';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import InfoIcon from '@mui/icons-material/Info';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import ChatIcon from '@mui/icons-material/Chat';
import { Save } from '@mui/icons-material';
import AttachmentIcon from '@mui/icons-material/Attachment';
import WarningIcon from '@mui/icons-material/Warning';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FilterListIcon from '@mui/icons-material/FilterList';
import CardMedia from '@mui/material/CardMedia';
import LockOpenIcon from '@mui/icons-material/LockOpen';


export const material = {
    LockOpenIcon,
    CardMedia,
    FilterListIcon,
    ShoppingCartIcon,
    WarningIcon,
    AttachmentIcon,
    Save,
    ChatIcon,
    SaveAsIcon,
    InfoIcon,
    AccessTimeIcon,
    ContentCopyIcon,
    AddLinkIcon,
    Fade,
    Alert,
    RefreshIcon,
    Grid,
    ReplayIcon,
    SkipPreviousIcon,
    PhotoSizeSelectActualIcon,
    TextsmsIcon,
    CampaignIcon,
    CheckBoxIcon,
    CheckBoxOutlineBlankIcon,
    EmailIcon,
    CallIcon,
    CircularProgress,
    Skeleton,
    SkipNextIcon,
    PrintIcon,
    DateTimeField,
    NoteAddIcon,
    StoreIcon,
    TimePicker,
    ListIcon,
    SendIcon,
    AddCircleIcon,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    TabContext,
    TabPanel,
    TabList,
    Tab,
    Tabs,
    ArrowRightIcon,
    OutlinedInput,
    UploadIcon,
    AddCircleOutlineIcon,
    FormGroup,
    KeyboardArrowLeft,
    KeyboardArrowRight,
    MobileStepper,
    ReceiptIcon,
    MedicationIcon,
    BookIcon,
    MonitorHeartIcon,
    HomeIcon,
    ExpandLess,
    ExpandMore,
    Collapse,
    GroupIcon,
    LocalAtmIcon,
    CalendarMonthIcon,
    KeyboardDoubleArrowLeftIcon,
    ChevronLeftIcon,
    MuiAppBar,
    DescriptionIcon,
    DownloadIcon,
    CreateNewFolderIcon,
    InsertDriveFileIcon,
    UploadFileIcon,
    FolderIcon,
    ChevronRightIcon,
    ExpandMoreIcon,
    Button,
    TreeItem,
    TreeView,
    IconButton,
    ReplyIcon,
    Checkbox,
    TextField,
    AppBar,
    Autocomplete,
    ButtonGroup,
    Box,
    Fab,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    InputLabel,
    InputAdornment,
    PermIdentityIcon,
    KeyOutlinedIcon,
    VisibilityOffIcon,
    Input,
    ForwardToInboxIcon,
    MenuIcon,
    CreateIcon,
    ManageAccountsIcon,
    CloseIcon,
    MenuItem,
    Container,
    Select,
    Stack,
    Slider,
    Switch,
    ToggleButton,
    ToggleButtonGroup,
    Avatar,
    Badge,
    Chip,
    List,
    ListItem,
    ListItemText,
    ListItemButton,
    Divider,
    ListItemIcon,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Tooltip,
    Typography,
    Toolbar,
    DialogTitle,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    MuiDrawer,
    Card,
    CardContent,
    CardActions,
    Drawer,
    Snackbar,
    Link,
    Menu,
    Pagination,
    VisibilityIcon,
    ApartmentIcon,
    DateTimePicker,
    MedicalServicesOutlinedIcon,
    LogoutIcon,
    DeleteIcon,
    PersonIcon,
    TablePagination,
    DesktopDatePicker,
    MuiAlert,
    DashboardIcon,
    CardActionArea,
    AddIcon,
    ScheduleIcon,
    CameraAltIcon,
    AddAPhotoIcon,
    VideoCallIcon,
    DoneIcon,
    PriorityHighIcon,
    InventoryIcon,
    HourglassTopIcon,
    FormatListBulletedIcon,
    AttachMoneyIcon,
    CameraswitchIcon,
    CallEndIcon,
    MicOffIcon,
    MicIcon,
    ArrowDropDownIcon,
    ArrowDropUpIcon,
    CancelIcon,
    ConfirmationNumberIcon,
    DatePicker,
    ArrowForwardIcon,
    UserIcon,
    RoleIcon
};